import createClient from "openapi-react-query"

import { createApiClient } from "@/api/utils"
import { env } from "@/env"
import type { paths as otaPaths } from "@/types/api/ota/schema.gen"

const client = createApiClient<otaPaths>({ baseUrl: `${env.VITE_API2_URL}/ota` })

// Vanilla API client
export const $otaApiClient = client.vanillaClient

// React-Query client
export const $rqOtaApiClient = createClient(client.rqClient)
